module.exports = "/_next/static/images/fees_visualization-a8e8762bd0cb054d74fc7e8a26c43cc3.png";